import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { StyledBox } from "./styles";
import { Box } from "@mui/material";

const DraggableItem = ({
  element = {},
  order,
  Component,
  includeSnapshot,
}) => {
  const elementDraggableProps = element?.draggableProps || {};

  return (
    <Box
      {...elementDraggableProps}
      className={`HubDroppable-box HubDroppable-box-${order}`}
    >
      <Draggable
        draggableId={`${element?.id}`}
        index={order}
        isDragDisabled={!!element?.started}
      >
        {(provided, snapshot) => (
          <StyledBox
            className="HubDraggable-root"
            isDragging={snapshot.isDragging}
            draggableStyle={provided.draggableProps.style}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <Component
              {...element}
              {...(includeSnapshot ? { snapshot } : {})}
              isDragging={snapshot.isDragging}
            />
          </StyledBox>
        )}
      </Draggable>
    </Box>
  );
};

export default DraggableItem;
